<template>
  <j-modal :title="title" :width="750" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false"
    :body-style="{ height: '650px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk" @cancel="handleCancel"
    :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <div>
        <div style="">
          <div style="border: 1px solid #eee;padding: 10px;height: 350px;">
            <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
              <img :src="scanImg" alt="" style="width: 100%;height: 100%;" v-if="scanImg" />
              <div v-else><em>{{ $t('摄像头暂未开启') }}</em></div>
            </div>
          </div>
          <div style="display: flex;justify-content: space-evenly;margin-top: 10px;">
            <a-button type="default" @click="onStartScan" :disabled="capture">
                {{ $t('开启扫描') }}
            </a-button>
            <a-button type="primary" @click="onOkScan" :disabled="!capture">
                {{ $t('确认') }}
            </a-button>
          </div>
        </div>
        <div style="margin-top: 10px;">
          <detail-list :col="1">
            <detail-list-item :term="$t('用户纸质资料')"></detail-list-item>
            <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="userInfo.scanImgs" @change="onChange"></j-image-upload>
          </detail-list>
        </div>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>
  import { uploadAction } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import Vue from 'vue'
  export default {
    name: 'ScanUserFolderModal',
    components: {
      DetailList,
      DetailListItem,
      JImageUpload
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        userInfo: {},
        fileList: [],
        url:{
          upload: "sys/common/upload",
        },
        scanImg: '',
        capture: false,
      }
    },
    methods: {
      onChange(e){
        this.fileList = e&&e.split(',');
      },
      init(imgs) {
        this.title = this.$t('扫描用户资料');
        this.visible = true;
        this.$nextTick(()=>{
          if(imgs){
            this.userInfo = {
              scanImgs: imgs&&imgs.join(',')
            };
            this.fileList = imgs;
          }else{
            this.userInfo = {
              scanImgs: ''
            };
            this.fileList = [];
          }
        })
        this.scanImg = '';
        this.capture = false;
        this.initWebSocket();
      },
      handleOk() {
        this.$emit('ok', this.userInfo);
        this.close();
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      onStartScan(){
        if(this.fileList.length<20){
          this.$message.success(this.$t('请将资料放置摄像头下，正在开启扫描。请稍等！'));
          var json1 = {"Type":"1","Method":"star_OpenCam","nIndex":"0","szRes":"640x480"};
          this.websocketSend(JSON.stringify(json1));
          this.capture = true;
        }else{
          this.$message.warning(this.$t('最多扫描20张，如果要继续扫描请删除之前的图片！'));
        }
      },
      onOkScan(){
        var json2 = {"Type":"1","Method":"star_Capture","szPhotoPath":"D:\\scan1.jpg","nIndex":"0"};
        this.websocketSend(JSON.stringify(json2));
        this.capture = false;
      },
      // websocket消息通知开始
      initWebSocket() {
        // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
        var userId = this.$store.getters.userInfo.id;
        // var url = window._CONFIG['domianURL'].replace("https://", "wss://").replace("http://", "ws://") + "/websocket/" + userId;
        // var url = 'ws://localhost:19998/'
        // var url = 'http://172.16.8.137:19998/'
        var url = 'http://127.0.0.1:19998/'

        //update-begin-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        let token = Vue.ls.get('ACCESS_TOKEN')

        this.websocket = new WebSocket(url);
        //update-end-author:taoyan date:2022-4-22 for:  v2.4.6 的 websocket 服务端，存在性能和安全问题。 #3278
        this.websocket.onopen = this.websocketOnopen;
        this.websocket.onerror = this.websocketOnerror;
        this.websocket.onmessage = this.websocketOnmessage;
        this.websocket.onclose = this.websocketOnclose;
      },
      websocketOnopen() {
        console.log("WebSocket消息通知layout连接成功");
        //心跳检测重置
        // this.heartCheck.reset().start();
      },
      websocketOnerror(e) {
        console.log("WebSocket连接发生错误，第%s次", this.wsConnectErrorTime);

        this.wsConnectErrorTime = this.wsConnectErrorTime + 1;
        if (this.wsConnectErrorTime > 5) {
          console.log("WebSocket连接错误超过5次，就不再重新连了！");
          this.lockReconnect = true
          return;
        }
        // this.reconnect();
      },
      websocketOnmessage(e) {
        let data = JSON.parse(e.data); //解析json字符串
        console.log("WebSocket消息通知layout收到消息", data);
        // 按照实际需求处理消息（即只推送给含有特定消息类型的用户）
        // if(this.messageType.findIndex(item => item == data.port) == -1) {
        //   return
        // }
        console.log(data);
        if(data.Type == 1 && data.Method == "star_Preview" && data.nIndex == 0){// 预览结果
          if(data.ret == 0){
            this.scanImg = "data:image/png; base64,"+data.szPhotoBase64;
          }
        }else if(data.Type == 1 && data.Method == "star_Capture" && data.nIndex == 0){// 扫描拍照结果
          if(data.ret == 0){
            this.scanImg = "data:image/png; base64,"+data.szPhotoBase64;
            var szPicData = data.szPhotoBase64;
            var pdfUrl = atob(szPicData);
            var pdfNumbers = pdfUrl.length;
            var pdfArray = new Uint8Array(pdfNumbers);
            while( pdfNumbers-- ){
              pdfArray[pdfNumbers] = pdfUrl.charCodeAt(pdfNumbers)
            }
            var file = new File([pdfArray],'用户纸质资料.png',{type: 'image/png'});
            
            let formData = new FormData();
            formData.append('biz','temp');
            formData.append('file',file);
            uploadAction(this.url.upload,formData).then(res=>{
              if(res.success){
                console.log(res.message);
                this.fileList.push(res.message);
                this.userInfo.scanImgs = this.fileList.join(',');
                let json = {"Type":"1","Method":"star_CloseCam","nIndex":"0"};// 关闭摄像头
                this.websocketSend(JSON.stringify(json));
                setTimeout(()=>{
                  this.scanImg = '';
                },1000)
              }
            })
          }
        }
      },
      websocketOnclose(e) {
        console.log("connection closed (" + e + ")");
        if (e) {
          console.log("connection closed (" + e.code + ")");
        }
        // this.reconnect();
      },
      websocketSend(text) { // 数据发送
        try {
          this.websocket.send(text);
        } catch (err) {
          console.log("send failed (" + err.code + ")");
        }
      },
    }
  }
</script>
<style scoped>
  /deep/.detail-list .content {
    line-height: normal;
  }
  /deep/.ant-upload.ant-upload-select-picture-card{
    display: none;
  }
</style>